webpackJsonp([1],{

/***/ "+D+3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60ma":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EEbw":
/***/ (function(module, exports) {

module.exports = {"version":"0.20.2"}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad49406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pTVg");
function injectStyle (ssrContext) {
  __webpack_require__("60ma")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad49406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "R/pS":
/***/ (function(module, exports) {

module.exports = [{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"name","outputs":[{"name":"o_name","type":"bytes32"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"owner","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"content","outputs":[{"name":"","type":"bytes32"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"addr","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"reserve","outputs":[],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"subRegistrar","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_newOwner","type":"address"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_registrar","type":"address"}],"name":"setSubRegistrar","outputs":[],"type":"function"},{"constant":false,"inputs":[],"name":"Registrar","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_a","type":"address"},{"name":"_primary","type":"bool"}],"name":"setAddress","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_content","type":"bytes32"}],"name":"setContent","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"disown","outputs":[],"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_name","type":"bytes32"},{"indexed":false,"name":"_winner","type":"address"}],"name":"AuctionEnded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_name","type":"bytes32"},{"indexed":false,"name":"_bidder","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"NewBid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"}],"name":"Changed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"},{"indexed":true,"name":"addr","type":"address"}],"name":"PrimaryChanged","type":"event"}]

/***/ }),

/***/ "UIsv":
/***/ (function(module, exports) {

module.exports = [{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"owner","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_refund","type":"address"}],"name":"disown","outputs":[],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"addr","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"reserve","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_newOwner","type":"address"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_a","type":"address"}],"name":"setAddr","outputs":[],"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"}],"name":"Changed","type":"event"}]

/***/ }),

/***/ "UWDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FiveMedium"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"fees"},[_vm._v("\n    Fee to post: "),_c('span',[_vm._v(_vm._s(_vm.newThreadEther()))]),_vm._v(" ethers"),_c('br'),_vm._v("\n    Fee to reply: "),_c('span',[_vm._v(_vm._s(_vm.newReplyEther()))]),_vm._v(" ethers\n  ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" Warning: there is "),_c('strong',[_vm._v("NO")]),_vm._v(" moderation. People can post anything and you might get shocked. Images and Videos are enabled by default, "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.nsfwFilter = !_vm.nsfwFilter}}},[_vm._v("click here")]),_vm._v(" to disable them.\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],staticClass:"alert"},[_vm._v("Your post was successfuly posted. It might take some time until your transaction is confirmed. If you are using Metamask, you might have to reload the page to see the change.")]),_vm._v(" "),(_vm.post_button)?_c('button',{staticClass:"post_thread",attrs:{"type":"button"},on:{"click":function($event){_vm.replyToThread();_vm.post_button = false; _vm.alert = false}}},[_vm._v("post something")]):_c('form',{staticClass:"post_thread"},[(_vm.noWallet)?_c('div',{staticClass:"nowallet"},[_vm._v("\n      You need to use a wallet to be able to post. Check "),_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("Metamask")]),_vm._v(" or "),_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("Mist")]),_vm._v(".\n    ")]):_c('div',[(_vm.activeAccount)?_c('div',[_c('label',{attrs:{"for":"account"}},[_vm._v("your account")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeAccount),expression:"activeAccount"}],attrs:{"name":"account","id":"account"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeAccount=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.accounts),function(account){return _c('option',[_vm._v(_vm._s(account))])})),_vm._v(" "),_c('label',{attrs:{"for":"image"}},[_vm._v("your image")]),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"http://image","id":"form_image","name":"image"}}),_vm._v(" "),_c('label',{attrs:{"for":"text"}},[_vm._v("your message")]),_vm._v(" "),_c('textarea',{attrs:{"placeholder":"your text","id":"form_text","name":"text"}}),_c('br'),_vm._v(" "),_c('button',{staticClass:"post_thread_finish",attrs:{"type":"button"},on:{"click":_vm.post_thread}},[_vm._v("submit")])]):_c('div',[_vm._v("\n        You need to connect your account to this DAPP. In Mist you can do it by clicking on \"connect\" in the upper right corner.\n      ")])])]),_vm._v(" "),_c('nav',[_vm._v("the last 20 active threads ⬇")]),_vm._v(" "),_c('section',{staticClass:"articles"},_vm._l((_vm.threads),function(thread){return _c('article',[_c('h2',[_c('i',{staticClass:"fa fa-hashtag",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(thread.timestamp))]),_vm._v(" "),_c('div',{staticClass:"postContent"},[(thread.displayVideo && !_vm.nsfwFilter)?_c('video',{attrs:{"preload":"auto","autoplay":"autoplay","muted":"muted","loop":"loop","webkit-playsinline":""}},[_c('source',{attrs:{"src":thread.imageUrl,"type":"video/mp4"}})]):(thread.displayImage && !_vm.nsfwFilter)?_c('img',{attrs:{"src":thread.imageUrl},on:{"error":function($event){_vm.noImage(thread.threadId, 0)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(thread.text))])]),_vm._v(" "),_c('div',{staticClass:"replies"},[_vm._l((thread.replies),function(reply){return _c('div',{staticClass:"reply"},[_c('h3',[_c('i',{staticClass:"fa fa-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(reply.timestamp))]),_vm._v(" "),_c('div',{staticClass:"postContent"},[(reply.displayVideo && !_vm.nsfwFilter)?_c('video',{attrs:{"preload":"auto","autoplay":"autoplay","muted":"muted","loop":"loop","webkit-playsinline":""}},[_c('source',{attrs:{"src":reply.imageUrl,"type":"video/mp4"}})]):(reply.displayImage && !_vm.nsfwFilter)?_c('img',{attrs:{"src":reply.imageUrl},on:{"error":function($event){_vm.noImage(thread.threadId, reply.replyId)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(reply.text))])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(thread.reply.alert),expression:"thread.reply.alert"}],staticClass:"alert_reply"},[_vm._v("Your post was successfuly posted. It might take some time until your transaction is confirmed. If you are using Metamask, you might have to reload the page to see the change.")]),_vm._v(" "),(_vm.noWallet)?void 0:[(thread.visibleReplyForm)?_c('form',{staticClass:"post_thread post_reply"},[(_vm.noWallet)?_c('div',{staticClass:"nowallet"},[_vm._v("\n              You need to use a wallet to be able to post. Check "),_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("Metamask")]),_vm._v(" or "),_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("Mist")]),_vm._v(".\n            ")]):_c('div',[_c('label',{attrs:{"for":"account"}},[_vm._v("your account")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeAccount),expression:"activeAccount"}],attrs:{"name":"account","id":"account"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeAccount=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.accounts),function(account){return _c('option',[_vm._v(_vm._s(account))])})),_vm._v(" "),_c('label',{attrs:{"for":"image"}},[_vm._v("your image")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(thread.reply.imageUrl),expression:"thread.reply.imageUrl"}],attrs:{"type":"text","placeholder":"http://image","name":"image"},domProps:{"value":(thread.reply.imageUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(thread.reply, "imageUrl", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"text"}},[_vm._v("your message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(thread.reply.text),expression:"thread.reply.text"}],attrs:{"placeholder":"your text","name":"text"},domProps:{"value":(thread.reply.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(thread.reply, "text", $event.target.value)}}}),_c('br'),_vm._v(" "),_c('button',{staticClass:"post_thread_finish",attrs:{"type":"button"},on:{"click":function($event){_vm.reply_thread(thread.threadId)}}},[_vm._v("submit")])])]):_c('button',{staticClass:"reply-to-thread",on:{"click":function($event){_vm.replyToThread(thread.threadId)}}},[_vm._v("Reply to this thread")])]],2)])})),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('i',{staticClass:"fa fa-hand-peace-o",attrs:{"aria-hidden":"true"}}),_vm._v(" DAS 5MEDIUM EXPERIMENT")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"explanations"},[_c('strong',[_vm._v("What is this?")]),_vm._v(" It's a "),_c('a',{attrs:{"href":"https://ethereum.stackexchange.com/questions/383/what-is-a-dapp","target":"_blank"}},[_vm._v("DAPP")]),_vm._v(" (for Decentralized Application). It lives on the "),_c('img',{attrs:{"src":"https://i.imgur.com/ypBYD0o.png"}}),_c('strong',[_vm._v("ethereum blockchain")]),_vm._v(" meaning that nothing is stored in a database. Isn't that incredible? To post a thread or reply to a post you will need a compatible wallet like "),_c('a',{attrs:{"href":"https://github.com/ethereum/mist","target":"_blank"}},[_vm._v("Mist")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://metamask.io/","target":"_blank"}},[_vm._v("Metamask")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    Created by "),_c('a',{attrs:{"href":"/"}},[_vm._v("David Wong")]),_vm._v(". Checkout this "),_c('a',{attrs:{"href":"https://cryptologie.net/article/424/writing-a-dapp-for-the-ethereum-block-chain/","target":"_blank"}},[_vm._v("blogpost")]),_vm._v(" for more information on the project.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UqXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_web3__ = __webpack_require__("8k0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_web3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_web3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__smart_build_contracts_FiveMedium_json__ = __webpack_require__("ip/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__smart_build_contracts_FiveMedium_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__smart_build_contracts_FiveMedium_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

//
// Vuex Store for threads and replies
// 

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    threads: []
  },
  getters: {
    reversedThreads: function reversedThreads(state) {
      return state.threads.slice().reverse();
    }
  },
  mutations: {
    // Push a thread object into our dynamic list of threads 
    // (maxSize should be of 20 threads)
    pushToThreads: function pushToThreads(state, thread) {
      // debug
      console.log("adding thread to our threads:", thread);

      // check that the thread is not already there
      for (var i = 0; i < state.threads.length; i++) {
        if (state.threads[i].threadId == thread.threadId) return;
      }

      // TODO: is that secure?
      var imageUrl = thread.imageUrl;
      var displayImage = true;
      var displayVideo = false;
      if (!imageUrl.startsWith('http') && !imageUrl.startsWith('data:') || imageUrl.search('goatse') != -1) {
        displayImage = false;
      } else if (imageUrl.endsWith('.mp4')) {
        displayVideo = true;
      }

      // push
      //  console.log(thread)
      state.threads.push({
        timestamp: thread.timestamp,
        threadId: thread.threadId,
        text: thread.text,
        displayImage: displayImage,
        displayVideo: displayVideo,
        imageUrl: imageUrl,
        replies: thread.replies,
        visibleReplyForm: false,
        reply: { imageUrl: "", text: "" }
      });

      // remove first (older) element 
      //  if we have more than 20 threads
      if (state.threads.length > 20) {
        state.threads.shift();
      }
    },
    // end pushToThreads()

    // payload{threadId, reply{}}
    pushReply: function pushReply(state, payload) {

      // check that the reply is not already there
      for (var i = 0; i < state.threads.length; i++) {
        if (state.threads[i].threadId == payload.threadId) {
          for (var j = 0; j < state.threads[i].replies.length; j++) {
            if (state.threads[i].replies[j].replyId == payload.reply.replyId) {
              return;
            }
          }
        }
      }

      // image?
      payload.reply.displayImage = true;
      payload.reply.displayVideo = false;
      if (!payload.reply.imageUrl.startsWith('http') && !payload.reply.imageUrl.startsWith('data:')) {
        payload.reply.displayImage = false;
      } else if (payload.reply.imageUrl.endsWith('.mp4')) {
        payload.reply.displayVideo = true;
      }

      // debug
      console.log("adding reply to thread:", payload.threadId, ":", payload.reply);
      // check that the thread is on the front page
      for (var i = 0; i < state.threads.length; i++) {
        if (state.threads[i].threadId == payload.threadId) {
          state.threads[i].replies.push(payload.reply);
          return;
        }
      }
    } // end pushReply()

  } // end mutations {}
});

//
// FiveMedium Core
// 

function fetchReply(threadId, nextNode) {
  if (nextNode != 0) {
    contract.replies.call(nextNode, function (err, replyArray) {
      // reply object
      var reply = {
        replyId: nextNode,
        text: replyArray[0],
        imageUrl: replyArray[1],
        timestamp: replyArray[4].toNumber()
      };
      store.commit('pushReply', { threadId: threadId, reply: reply });
      nextNode = replyArray[3].toNumber();
      fetchReply(threadId, nextNode);
    }); // end contract.replies()
  } // end if()
}

//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FiveMedium',
  data: function data() {
    return {
      feeNewThread: 0, // fee to post thread
      feeReplyThread: 0, // fee to reply to a thread

      post_button: true, // button to post a message
      alert: false,

      noWallet: true,
      accounts: [], // user accounts
      activeAccount: null, // the account to buy

      nsfwFilter: false
    };
  },

  computed: {
    threads: function threads() {
      return store.getters.reversedThreads;
    }
  },
  methods: {
    noImage: function noImage(threadId, replyId) {
      this.threads.forEach(function (val) {
        if (val.threadId === undefined) return;
        if (val.threadId == threadId) {
          if (replyId == 0) {
            val.displayImage = false;
            return;
          }
          val.replies.forEach(function (val2) {
            if (val2.replyId == replyId) {
              val2.replyId.displayImage = false;
              return;
            }
          });
        }
      });
    },
    replyToThread: function replyToThread(threadId) {
      this.threads.forEach(function (val) {
        val.reply.alert = false;
        if (val.threadId == threadId) {
          val.visibleReplyForm = true;
        } else {
          val.visibleReplyForm = false;
        }
      });
      this.post_button = true;
    },
    newThreadEther: function newThreadEther() {
      return new __WEBPACK_IMPORTED_MODULE_2_web3___default.a().fromWei(this.feeNewThread, "ether");
    },
    newReplyEther: function newReplyEther() {
      return new __WEBPACK_IMPORTED_MODULE_2_web3___default.a().fromWei(this.feeReplyThread, "ether");
    },
    reply_thread: function reply_thread(threadId) {

      var text = '';
      var imageUrl = '';

      this.threads.forEach(function (val) {
        if (val.threadId == threadId) {
          text = val.reply.text;
          imageUrl = val.reply.imageUrl;
        }
      });

      contract.replyThread.sendTransaction(threadId, text, imageUrl, { value: this.feeReplyThread, from: this.activeAccount }, function (err, res) {

        if (err) {
          if (err.message && err.message.indexOf('User denied transaction signature.') !== -1) {
            // Aborted, revert to original state.
            return;
          }
          console.log(err.toString());
          return;
        }

        console.log("success replying");
        this.replyToThread(); // hide form

        this.threads.forEach(function (val) {
          if (val.threadId == threadId) {
            val.reply.alert = true;
            val.reply.text = '';
            val.reply.imageUrl = '';
          }
        });
      }.bind(this));
    },
    // end post_thread()

    post_thread: function post_thread(event) {
      var text = document.getElementById("form_text").value;
      var imageUrl = document.getElementById("form_image").value;

      contract.createThread.sendTransaction(text, imageUrl, { value: this.feeNewThread, from: this.activeAccount }, function (err, res) {

        if (err) {
          if (err.message && err.message.indexOf('User denied transaction signature.') !== -1) {
            // Aborted, revert to original state.
            return;
          }
          console.log(err.toString());
          return;
        }

        console.log("success");
        this.alert = true;
        this.post_button = true;
        document.getElementById("form_image").value = "";
        document.getElementById("form_text").value = "";
      }.bind(this));
    }
  },
  mounted: function mounted() {
    var _this = this;

    // different contract address for different networks
    var FiveMediumRinkebyAddress = "0x41e1Fc1E038560BF3E70509477097d450F1748D7";
    var FiveMediumLocalAddress = "0xac2ece9820e03fef74d3c66fd616d78edbdc70ca";
    var FiveMediumMainNetAddress = "0x470fb19D08c3d2eB8923A31d1408c393Dab09ccF";
    var debug = false;

    // by default we use the Rinkeby address
    var FiveMediumAddress = FiveMediumRinkebyAddress;

    // connect to network
    var FiveMediumAddress;
    if (typeof web3 !== 'undefined') {
      // wallet
      console.log("using the application's web3 version");
      window.web3 = new __WEBPACK_IMPORTED_MODULE_2_web3___default.a(web3.currentProvider);
      this.noWallet = false;
    } else {
      if (!debug) {
        // no wallet
        console.log("using Infura web3");
        //        window.web3 = new Web3(new Web3.providers.HttpProvider("https://rinkeby.infura.io/OOnNmO1GACWlnqKpps53"));
        window.web3 = new __WEBPACK_IMPORTED_MODULE_2_web3___default.a(new __WEBPACK_IMPORTED_MODULE_2_web3___default.a.providers.HttpProvider("https://mainnet.infura.io/OOnNmO1GACWlnqKpps53"));
      } else {
        // testing
        console.log("using local web3");
        window.web3 = new __WEBPACK_IMPORTED_MODULE_2_web3___default.a(new __WEBPACK_IMPORTED_MODULE_2_web3___default.a.providers.HttpProvider("http://localhost:8545"));
      }
    }

    // what network are we on?
    web3.version.getNetwork(function (err, netId) {
      console.log("debug");
      switch (netId) {
        case "1":
          console.log('This is mainnet');
          FiveMediumAddress = FiveMediumMainNetAddress;
          break;
        case "4":
          console.log("Using the Rinkeby test network");
          FiveMediumAddress = FiveMediumRinkebyAddress;
          break;
        default:
          console.log('This is an unknown network:', netId);
          FiveMediumAddress = FiveMediumLocalAddress;
      }

      // get the user accounts
      web3.eth.getAccounts(function (err, accounts) {
        this.activeAccount = accounts[0];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(accounts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var account = _step.value;

            this.accounts.push(account);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }.bind(_this));

      // get contract
      console.log("connected:", web3.currentProvider.isConnected());
      window.contract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(web3.eth.contract(__WEBPACK_IMPORTED_MODULE_3__smart_build_contracts_FiveMedium_json___default.a.abi).at(FiveMediumAddress));
      console.log("fetching contract at", FiveMediumAddress);

      // debug
      console.log("the contract interface:", contract.abi);

      // get public fees
      contract.feeNewThread.call(function (err, val) {
        this.feeNewThread = val.toNumber();
        console.log("setting feeNewThread to", this.feeNewThread);
      }.bind(_this));
      contract.feeReplyThread.call(function (err, val) {
        this.feeReplyThread = val.toNumber();
      }.bind(_this));

      // get 20 last threadIds 
      // TODO: this is async so it will be unsorted, change that by providing the "i" so that the store
      //       stores it under the right index in its array (of fixed 20 elements!!)
      console.log("retrieving last 20 threads");
      contract.indexLastThreads.call(function (err, val) {
        var indexLastThreads = val.toNumber();
        console.log("indexLastThreads:", indexLastThreads);

        for (var i = 0; i < 20; i++) {
          try {

            // threadId = lastThreads[indexLastThreads]
            console.log("fetch threadId of indexLastThreads", indexLastThreads);
            contract.lastThreads.call(indexLastThreads, function (err, threadId) {
              threadId = threadId.toNumber();
              console.log("retrieved threadId", threadId);
              // check if these is something to fetch
              if (threadId == 0) {
                return;
              }
              // threadArray = threads[threadId]
              contract.threads.call(threadId, function (err, threadArray) {

                // fetch replies
                var replies = [];
                var indexLastReply = threadArray[2].toNumber();
                var nextNode = threadArray[3].toNumber();

                fetchReply(threadId, nextNode);

                // push thread + replies to list
                var thread = {
                  threadId: threadId,
                  text: threadArray[0],
                  imageUrl: threadArray[1],
                  timestamp: threadArray[4].toNumber(),
                  replies: replies
                };
                store.commit('pushToThreads', thread);
              }.bind(this)); // end this.contract.threads()
            }.bind(this)); // end this.contract.lastThreads
          } catch (e) {
            // end of try {}
            continue;
          }

          // fetch next thread id (DESC)
          indexLastThreads = (indexLastThreads + 1) % 20;
        } // end for loop

      }.bind(_this)); // end this.contract.indexLastThreads

      // watch new thread event
      var newThreadEvent = contract.newThreadEvent().watch(function (error, newThread) {
        console.log("newThreadEvent received.", newThread, error);
        if (!error) {
          var thread = {
            threadId: newThread.args.threadId.toNumber(),
            text: newThread.args.text,
            imageUrl: newThread.args.imageUrl,
            timestamp: newThread.args.timestamp.toNumber(),
            replies: []
          };
          store.commit('pushToThreads', thread);
        } // end if (!error)
      }); // end newThreadEvent.watch()

      // watch new reply event
      var newReplyEvent = contract.newReplyEvent().watch(function (error, newReply) {
        if (!error) {
          console.log("newReplyEvent received.", newReply);
          var replyTo = newReply.args.replyTo.toNumber();
          // reply object
          var reply = {
            replyId: newReply.args.replyId.toNumber(),
            text: newReply.args.text,
            imageUrl: newReply.args.imageUrl,
            timestamp: newReply.args.timestamp.toNumber()
          };
          store.commit('pushReply', { threadId: replyTo, reply: reply });
        } // end if (!error)
      }); // end newReplyEvent.watch()

    }); // end of web3.version.getNetwork()

  } // end async mounted()

}); // end component

/***/ }),

/***/ "XG++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiveMediumForWallets_vue__ = __webpack_require__("UqXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b5b22d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiveMediumForWallets_vue__ = __webpack_require__("UWDh");
function injectStyle (ssrContext) {
  __webpack_require__("+D+3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiveMediumForWallets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b5b22d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiveMediumForWallets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FiveMediumForWallets__ = __webpack_require__("XG++");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'FiveMedium',
    component: __WEBPACK_IMPORTED_MODULE_2__components_FiveMediumForWallets__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ip/G":
/***/ (function(module, exports) {

module.exports = {"contract_name":"FiveMedium","abi":[{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"lastThreads","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_feeNewThread","type":"uint256"},{"name":"_feeReplyThread","type":"uint256"}],"name":"SetFees","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"feeNewThread","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"replies","outputs":[{"name":"text","type":"string"},{"name":"imageUrl","type":"string"},{"name":"replyTo","type":"uint256"},{"name":"nextReply","type":"uint256"},{"name":"timestamp","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_replyTo","type":"uint256"},{"name":"_text","type":"string"},{"name":"_imageUrl","type":"string"}],"name":"replyThread","outputs":[],"payable":true,"type":"function"},{"constant":true,"inputs":[],"name":"feeReplyThread","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"indexReplies","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"indexLastThreads","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_text","type":"string"},{"name":"_imageUrl","type":"string"}],"name":"createThread","outputs":[],"payable":true,"type":"function"},{"constant":true,"inputs":[],"name":"indexThreads","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"uint256"}],"name":"threads","outputs":[{"name":"text","type":"string"},{"name":"imageUrl","type":"string"},{"name":"indexLastReply","type":"uint256"},{"name":"indexFirstReply","type":"uint256"},{"name":"timestamp","type":"uint256"}],"payable":false,"type":"function"},{"inputs":[{"name":"_feeNewThread","type":"uint256"},{"name":"_feeReplyThread","type":"uint256"}],"payable":false,"type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"threadId","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newThreadEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"replyId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newReplyEvent","type":"event"}],"unlinked_binary":"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","networks":{"1508807256324":{"events":{"0xb85fdd0607260b9c85f58544bafa844f0d69473b2bc915a934336076406ae447":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"}],"name":"ThreadEvent","type":"event"}},"links":{},"address":"0x5729f12897d2a6a823e54e676ee1e28a0fe71e01","updated_at":1508807469913},"1508807491940":{"events":{"0xb85fdd0607260b9c85f58544bafa844f0d69473b2bc915a934336076406ae447":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"}],"name":"ThreadEvent","type":"event"}},"links":{},"address":"0xfa217f887fd980d42fbc1774028ea1dd1841b4a4","updated_at":1508807498052},"1508807528157":{"events":{"0xb85fdd0607260b9c85f58544bafa844f0d69473b2bc915a934336076406ae447":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"}],"name":"ThreadEvent","type":"event"}},"links":{},"address":"0x3ac46ce87481f9e2fef6549dbbdc92e29d1d16ef","updated_at":1508807532197},"1508807644666":{"events":{"0xb85fdd0607260b9c85f58544bafa844f0d69473b2bc915a934336076406ae447":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"}],"name":"ThreadEvent","type":"event"}},"links":{},"address":"0xd781ab1a536a1911bf82391b41e220a864f0a49a","updated_at":1508807648210},"1508837377488":{"events":{"0xb85fdd0607260b9c85f58544bafa844f0d69473b2bc915a934336076406ae447":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"}],"name":"ThreadEvent","type":"event"},"0xc48d8f60e5e67ddbe3f0ffb18f5db7f0b40d713de4c2bd5796b2cf392c218330":{"anonymous":false,"inputs":[{"indexed":false,"name":"messageId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"ThreadEvent","type":"event"},"0x19aec6a975c3906841d0bc9754286c99d208604b3e71f08a017e331f45b9a313":{"anonymous":false,"inputs":[{"indexed":false,"name":"threadId","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newThreadEvent","type":"event"},"0x0a10376fec2af3cfd7b84cf2d443bc3479c71cc96b6523d20fc876f4cdce7451":{"anonymous":false,"inputs":[{"indexed":false,"name":"replyId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newReplyEvent","type":"event"}},"links":{},"address":"0x6937d32d12e0e5b4d0f4db79c358069c7d1c4ccf","updated_at":1508850662011},"1508850856996":{"events":{"0x19aec6a975c3906841d0bc9754286c99d208604b3e71f08a017e331f45b9a313":{"anonymous":false,"inputs":[{"indexed":false,"name":"threadId","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newThreadEvent","type":"event"},"0x0a10376fec2af3cfd7b84cf2d443bc3479c71cc96b6523d20fc876f4cdce7451":{"anonymous":false,"inputs":[{"indexed":false,"name":"replyId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newReplyEvent","type":"event"}},"links":{},"address":"0xf31835239aacd06d058306e84f02fee1c638c3bd","updated_at":1508855444912},"1508935800860":{"events":{"0x19aec6a975c3906841d0bc9754286c99d208604b3e71f08a017e331f45b9a313":{"anonymous":false,"inputs":[{"indexed":false,"name":"threadId","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newThreadEvent","type":"event"},"0x0a10376fec2af3cfd7b84cf2d443bc3479c71cc96b6523d20fc876f4cdce7451":{"anonymous":false,"inputs":[{"indexed":false,"name":"replyId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newReplyEvent","type":"event"}},"links":{},"address":"0x3ca259a63204189816de052b7f7ee3ca6b1eba2f","updated_at":1508956154808},"1509028552697":{"events":{"0x19aec6a975c3906841d0bc9754286c99d208604b3e71f08a017e331f45b9a313":{"anonymous":false,"inputs":[{"indexed":false,"name":"threadId","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newThreadEvent","type":"event"},"0x0a10376fec2af3cfd7b84cf2d443bc3479c71cc96b6523d20fc876f4cdce7451":{"anonymous":false,"inputs":[{"indexed":false,"name":"replyId","type":"uint256"},{"indexed":false,"name":"replyTo","type":"uint256"},{"indexed":false,"name":"text","type":"string"},{"indexed":false,"name":"imageUrl","type":"string"},{"indexed":false,"name":"timestamp","type":"uint256"}],"name":"newReplyEvent","type":"event"}},"links":{},"address":"0xac2ece9820e03fef74d3c66fd616d78edbdc70ca","updated_at":1509028563922}},"schema_version":"0.0.5","updated_at":1509028563922}

/***/ }),

/***/ "oPsS":
/***/ (function(module, exports) {

module.exports = [{"constant":false,"inputs":[{"name":"from","type":"bytes32"},{"name":"to","type":"address"},{"name":"value","type":"uint256"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"from","type":"bytes32"},{"name":"to","type":"address"},{"name":"indirectId","type":"bytes32"},{"name":"value","type":"uint256"}],"name":"icapTransfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"to","type":"bytes32"}],"name":"deposit","outputs":[],"payable":true,"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"AnonymousDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"bytes32"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"bytes32"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"bytes32"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"indirectId","type":"bytes32"},{"indexed":false,"name":"value","type":"uint256"}],"name":"IcapTransfer","type":"event"}]

/***/ }),

/***/ "pTVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ee741d8decb12dde553f.js